import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-2 bg-light" }
const _hoisted_2 = { class: "row mb-2 d-print-none" }
const _hoisted_3 = { class: "col-md-3 col-4 fs-6 fw-bold" }
const _hoisted_4 = { class: "row pe-2" }
const _hoisted_5 = { class: "col-md-12 div-table-boletos pe-2" }
const _hoisted_6 = { class: "table table-striped table-hover table-sm table-bordered" }
const _hoisted_7 = { class: "th-fixed" }
const _hoisted_8 = { class: "col-md-12 text-center table-danger" }
const _hoisted_9 = {
  colspan: "15",
  class: "text-center"
}
const _hoisted_10 = { class: "d-inline" }
const _hoisted_11 = {
  class: "text-start d-print-none",
  "data-label": "Boleto Id"
}
const _hoisted_12 = {
  class: "text-start",
  "data-label": "Nº Documento"
}
const _hoisted_13 = {
  class: "text-start",
  "data-label": "Tipo Ocorrência"
}
const _hoisted_14 = {
  class: "text-end",
  "data-label": "Cliente"
}
const _hoisted_15 = {
  class: "text-start",
  "data-label": "Nome Cliente"
}
const _hoisted_16 = {
  class: "text-center",
  "data-label": "Dt. Vencto"
}
const _hoisted_17 = {
  class: "text-center",
  "data-label": "Dt. Pagto"
}
const _hoisted_18 = {
  class: "text-center",
  "data-label": "Dias astraso"
}
const _hoisted_19 = {
  class: "text-end",
  "data-label": "Valor R$"
}
const _hoisted_20 = {
  class: "text-end",
  "data-label": "Desc/Acresc R$"
}
const _hoisted_21 = {
  class: "text-end",
  "data-label": "Pago R$"
}
const _hoisted_22 = {
  class: "text-end",
  "data-label": "Receber R$"
}
const _hoisted_23 = {
  class: "text-center d-print-none",
  "data-label": "Opções"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "table-secondary fw-bold" }
const _hoisted_26 = { class: "text-start" }
const _hoisted_27 = { class: "text-end" }
const _hoisted_28 = { class: "text-end" }
const _hoisted_29 = { class: "text-end" }
const _hoisted_30 = { class: "text-end" }
const _hoisted_31 = { class: "text-end" }
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col-md-4" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-md-12" }
const _hoisted_36 = { class: "col-md-12" }
const _hoisted_37 = { class: "col-md-12" }
const _hoisted_38 = { class: "col-md-12" }
const _hoisted_39 = { class: "col-md-12" }
const _hoisted_40 = { class: "col-md-12" }
const _hoisted_41 = { class: "col-md-4" }
const _hoisted_42 = { class: "row" }
const _hoisted_43 = { class: "col-md-12" }
const _hoisted_44 = { class: "col-md-12" }
const _hoisted_45 = { class: "col-md-12" }
const _hoisted_46 = { class: "col-md-12" }
const _hoisted_47 = { class: "col-md-12" }
const _hoisted_48 = { class: "col-md-4" }
const _hoisted_49 = { class: "row" }
const _hoisted_50 = { class: "col-md-12" }
const _hoisted_51 = { class: "col-md-12" }
const _hoisted_52 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_53 = { class: "col-md-12" }
const _hoisted_54 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_55 = { class: "col-md-12" }
const _hoisted_56 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_57 = { class: "col-md-12" }
const _hoisted_58 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_59 = { class: "navbar fixed-bottom navbar-expand-lg navbar-dark bg-dark border-top d-print-none" }
const _hoisted_60 = { class: "container-fluid" }
const _hoisted_61 = {
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent"
}
const _hoisted_62 = { class: "d-flex" }
const _hoisted_63 = { class: "navbar-nav" }
const _hoisted_64 = { class: "nav-item" }

import { onMounted, reactive,} from "vue";
import { useRouter, useRoute } from 'vue-router';

//servicos
import * as service from "@/services/BoletosService";
import { fdata, f2dec } from "@/utils/funcoes";

//componentes
import MsgBox from "@/components/MsgBox/Index.vue";
import Loading from "@/components/Loading/index.vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'RetornoDiferencas',
  setup(__props) {


//vue
const router = useRouter();
const route = useRoute();

var controle = reactive({
    filtros: {
        retornoId: 0 
    } ,
    itens: [] as service.BoletoRelDif[],
    totais: {
        qtde: 0,
        valorDocumento: 0,
        valorMoraJuros: 0,
        valorPago: 0,
        valorDiferenca: 0,
        valorOutrosCreditos: 0,
        valorDesconto: 0,
        valorReceberMulta: 0,
        valorReceberJuros: 0,
        valorReceber: 0,
    },
    id: 0 as number,
    ordemDirecao: "Desc",
    ordemColuna: "BoletoId",

    item: {} as service.BoletoRelDif,
    janDetalhes: false,

    pesquisando: false,
    loading: false,
    status: "",
    erro: "",

    // Estados do diálogo de confirmação
    showConfirmDialog: false,
    processandoRetorno: false,

});

onMounted(() => {
    controle.filtros.retornoId = parseInt(route.params.id.toString());
    pesquisar();
})

const pesquisar = async () => {

    controle.erro = "";
    controle.pesquisando = true;
    controle.status = "Pesquisando...";
    controle.itens = [] as service.BoletoRelDif[];
    console.log("pesquisar");

    service.obterRetornoDiferencas(controle.filtros.retornoId as number)
        .then((r) => {
            controle.pesquisando = false;
            controle.status = "";
            controle.itens = r as service.BoletoRelDif[];

            controle.itens.forEach((boleto) => {
                controle.totais.qtde++;
                controle.totais.valorDocumento += (boleto.valorDocumento ?? 0);
                controle.totais.valorPago += (boleto.valorPago ?? 0);
                controle.totais.valorReceber += (boleto.valorReceber ?? 0);
                controle.totais.valorDiferenca =  controle.totais.valorPago - controle.totais.valorReceber;
                controle.totais.valorReceberJuros += (boleto.valorReceberJuros ?? 0);
            });

            

        })
        .catch((erro: string) => {
            controle.pesquisando = false;
            controle.erro = erro;
            controle.status = "Erro: " + erro + "<br> Tente novamente mais tarde";
        });
};

const ordenarPor = (coluna: string) => {
    if (controle.ordemColuna == coluna) {
        if (controle.ordemDirecao == "asc")
            controle.ordemDirecao = "desc";
        else
            controle.ordemDirecao = "asc";
    }
    else
        controle.ordemDirecao = "asc";

    controle.ordemColuna = coluna;

    if (controle.ordemDirecao == "asc")
        controle.itens = controle.itens.sort((a, b) => (a[coluna as keyof service.BoletoRelDif] > b[coluna as keyof service.BoletoRelDif]) ? 1 : ((b[coluna as keyof service.BoletoRelDif] > a[coluna as keyof service.BoletoRelDif]) ? -1 : 0));
    else
        controle.itens = controle.itens.sort((a, b) => (a[coluna as keyof service.BoletoRelDif] < b[coluna as keyof service.BoletoRelDif]) ? 1 : ((b[coluna as keyof service.BoletoRelDif] < a[coluna as keyof service.BoletoRelDif]) ? -1 : 0));
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Loading, {
      isLoading: _unref(controle).loading,
      mensagem: _unref(controle).status
    }, null, 8, ["isLoading", "mensagem"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "col-md-3 col-4 fs-6 fw-bold" }, " Diferenças ", -1)),
        _createElementVNode("div", _hoisted_3, " Retorno: " + _toDisplayString(_unref(controle).filtros.retornoId), 1),
        _cache[17] || (_cache[17] = _createElementVNode("div", { class: "col-md-3 col-4 fs-6 fw-bold" }, null, -1)),
        _cache[18] || (_cache[18] = _createElementVNode("div", { class: "col-md-3 col-4 fs-6 fw-bold" }, [
          _createElementVNode("a", {
            class: "btn btn-primary btn-sm float-end",
            style: {"cursor":"pointer"}
          }, [
            _createElementVNode("i", { class: "fa fa-print" }),
            _createTextVNode(" Imprimir ")
          ])
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("table", _hoisted_6, [
            _createElementVNode("thead", _hoisted_7, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  class: "text-start d-print-none",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (ordenarPor('boletoId')))
                }, "Id"),
                _createElementVNode("th", {
                  class: "text-start",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (ordenarPor('nossoNumero')))
                }, "Nº Documento"),
                _createElementVNode("th", {
                  class: "text-start",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (ordenarPor('descricaoTipoOcorrencia')))
                }, "Tipo Ocorrência"),
                _createElementVNode("th", {
                  class: "text-end",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (ordenarPor('clienteId')))
                }, "Cliente"),
                _createElementVNode("th", {
                  class: "text-start",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (ordenarPor('clienteNome')))
                }, "Razão social"),
                _createElementVNode("th", {
                  class: "text-center",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (ordenarPor('dataVencimento')))
                }, "Dt. Vencto"),
                _createElementVNode("th", {
                  class: "text-center",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (ordenarPor('dataVencimento')))
                }, "Dt. Pagto"),
                _createElementVNode("th", {
                  class: "text-center",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (ordenarPor('dataVencimento')))
                }, "Dias Atraso"),
                _createElementVNode("th", {
                  class: "text-end",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (ordenarPor('vendedorNome')))
                }, "Valor R$"),
                _createElementVNode("th", {
                  class: "text-end",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (ordenarPor('vendedorNome')))
                }, "Desc/Acres R$"),
                _createElementVNode("th", {
                  class: "text-end",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (ordenarPor('nomeCidade')))
                }, "Vlr Pago R$"),
                _createElementVNode("th", {
                  class: "text-end",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (ordenarPor('nomeCidade')))
                }, "Receber R$"),
                _createElementVNode("th", {
                  class: "text-end",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (ordenarPor('vendedorNome')))
                }, "Diferença R$"),
                _cache[19] || (_cache[19] = _createElementVNode("th", { class: "text-end d-print-none" }, null, -1))
              ])
            ]),
            _createElementVNode("tbody", null, [
              _withDirectives(_createElementVNode("tr", null, [...(_cache[20] || (_cache[20] = [
                _createElementVNode("td", {
                  colspan: "15",
                  class: "text-center"
                }, [
                  _createElementVNode("div", { class: "d-inline" }, [
                    _createElementVNode("i", { class: "fa fa-cog fa-spin" }),
                    _createTextVNode(" Pesquisando... ")
                  ])
                ], -1)
              ]))], 512), [
                [_vShow, _unref(controle).pesquisando == true]
              ]),
              _withDirectives(_createElementVNode("tr", _hoisted_8, [
                _createElementVNode("td", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _cache[21] || (_cache[21] = _createElementVNode("i", { class: "fa fa-exclamation" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_unref(controle).erro), 1)
                  ]),
                  _createElementVNode("a", {
                    class: "btn btn-primary btn-sm",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (pesquisar()))
                  }, "Repetir")
                ])
              ], 512), [
                [_vShow, _unref(controle).erro != '']
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).itens, (item, idx) => {
                return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                  _createElementVNode("td", _hoisted_11, _toDisplayString(item.boletoId), 1),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(item.numeroDocumento), 1),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(item.descricaoTipoOcorrencia), 1),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(item.clienteId), 1),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(item.nome), 1),
                  _createElementVNode("td", _hoisted_16, _toDisplayString(_unref(fdata)(item.dataVencimento)), 1),
                  _createElementVNode("td", _hoisted_17, _toDisplayString(_unref(fdata)(item.dataPagamento)), 1),
                  _createElementVNode("td", _hoisted_18, _toDisplayString(item.diasAtraso), 1),
                  _createElementVNode("td", _hoisted_19, _toDisplayString(_unref(f2dec)(item.valorDocumento)), 1),
                  _createElementVNode("td", _hoisted_20, _toDisplayString(_unref(f2dec)(item.valorMoraJuros + item.valorOutrosCreditos - item.valorDesconto)), 1),
                  _createElementVNode("td", _hoisted_21, _toDisplayString(_unref(f2dec)(item.valorPago)), 1),
                  _createElementVNode("td", _hoisted_22, _toDisplayString(_unref(f2dec)(item.valorReceber)), 1),
                  _createElementVNode("td", {
                    class: _normalizeClass(["text-end", item.valorDocumento - item.valorReceber > 0 ? 'text-primary':'text-danger']),
                    "data-label": "Diferença R$"
                  }, _toDisplayString(_unref(f2dec)( item.valorPago - item.valorReceber)), 3),
                  _createElementVNode("td", _hoisted_23, [
                    _createElementVNode("a", {
                      title: "Ver detalhes da diferença",
                      class: "",
                      style: {"cursor":"pointer"},
                      onClick: ($event: any) => {_unref(controle).item = item; _unref(controle).janDetalhes = true;}
                    }, [...(_cache[22] || (_cache[22] = [
                      _createElementVNode("i", { class: "fa fa-search" }, null, -1)
                    ]))], 8, _hoisted_24)
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("tfoot", null, [
              _createElementVNode("tr", _hoisted_25, [
                _cache[23] || (_cache[23] = _createElementVNode("td", { class: "text-end d-print-none" }, null, -1)),
                _cache[24] || (_cache[24] = _createElementVNode("td", { class: "text-end" }, null, -1)),
                _cache[25] || (_cache[25] = _createElementVNode("td", { class: "text-end" }, null, -1)),
                _createElementVNode("td", _hoisted_26, _toDisplayString(_unref(controle).itens.length) + " Registros", 1),
                _cache[26] || (_cache[26] = _createElementVNode("td", { class: "text-end" }, null, -1)),
                _cache[27] || (_cache[27] = _createElementVNode("td", { class: "text-end" }, null, -1)),
                _cache[28] || (_cache[28] = _createElementVNode("td", { class: "text-end" }, null, -1)),
                _createElementVNode("td", _hoisted_27, _toDisplayString(_unref(f2dec)(_unref(controle).totais.valorDocumento)), 1),
                _createElementVNode("td", _hoisted_28, _toDisplayString(_unref(f2dec)(_unref(controle).totais.valorMoraJuros + _unref(controle).totais.valorOutrosCreditos - _unref(controle).totais.valorDesconto)), 1),
                _createElementVNode("td", _hoisted_29, _toDisplayString(_unref(f2dec)(_unref(controle).totais.valorPago)), 1),
                _createElementVNode("td", _hoisted_30, _toDisplayString(_unref(f2dec)(_unref(controle).totais.valorReceber)), 1),
                _createElementVNode("td", _hoisted_31, _toDisplayString(_unref(f2dec)(_unref(controle).totais.valorDiferenca)), 1),
                _cache[29] || (_cache[29] = _createElementVNode("td", { class: "text-end d-print-none" }, null, -1))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(MsgBox, {
      id: 'janDetalhes',
      exibir: _unref(controle).janDetalhes,
      "botao-fechar": true,
      titulo: 'Detalhes',
      tamanho: 'modal-lg',
      onOnFechou: _cache[14] || (_cache[14] = ($event: any) => (_unref(controle).janDetalhes = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _cache[30] || (_cache[30] = _createElementVNode("b", null, "Boleto Id:", -1)),
                _createTextVNode(" " + _toDisplayString(_unref(controle).item.boletoId), 1)
              ]),
              _createElementVNode("div", _hoisted_36, [
                _cache[31] || (_cache[31] = _createElementVNode("b", null, "Nosso Número:", -1)),
                _createTextVNode(" " + _toDisplayString(_unref(controle).item.nossoNumero), 1)
              ]),
              _createElementVNode("div", _hoisted_37, [
                _cache[32] || (_cache[32] = _createElementVNode("b", null, "Cliente:", -1)),
                _createTextVNode(" " + _toDisplayString(_unref(controle).item.clienteId) + " - " + _toDisplayString(_unref(controle).item.nome), 1)
              ]),
              _createElementVNode("div", _hoisted_38, [
                _cache[33] || (_cache[33] = _createElementVNode("b", null, "Data vencimento:", -1)),
                _createTextVNode(" " + _toDisplayString(_unref(fdata)(_unref(controle).item.dataVencimento)), 1)
              ]),
              _createElementVNode("div", _hoisted_39, [
                _cache[34] || (_cache[34] = _createElementVNode("b", null, "Data dataPagamento:", -1)),
                _createTextVNode(" " + _toDisplayString(_unref(fdata)(_unref(controle).item.dataPagamento)), 1)
              ]),
              _createElementVNode("div", _hoisted_40, [
                _cache[35] || (_cache[35] = _createElementVNode("b", null, "Dias atraso:", -1)),
                _createTextVNode(" " + _toDisplayString(_unref(controle).item.diasAtraso), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _cache[41] || (_cache[41] = _createElementVNode("div", { class: "col-md-12" }, [
                _createElementVNode("b", null, "Sistema:")
              ], -1)),
              _createElementVNode("div", _hoisted_43, [
                _cache[36] || (_cache[36] = _createElementVNode("b", null, "Valor documento:", -1)),
                _createTextVNode(" " + _toDisplayString(_unref(f2dec)(_unref(controle).item.valorDocumento)), 1)
              ]),
              _createElementVNode("div", _hoisted_44, [
                _cache[37] || (_cache[37] = _createElementVNode("b", null, "Valor mora juros:", -1)),
                _createTextVNode(" " + _toDisplayString(_unref(f2dec)(_unref(controle).item.valorReceberJuros)), 1)
              ]),
              _createElementVNode("div", _hoisted_45, [
                _cache[38] || (_cache[38] = _createElementVNode("b", null, "Valor outros créditos:", -1)),
                _createTextVNode(" " + _toDisplayString(_unref(f2dec)(_unref(controle).item.valorReceberMulta)), 1)
              ]),
              _createElementVNode("div", _hoisted_46, [
                _cache[39] || (_cache[39] = _createElementVNode("b", null, "Valor desconto:", -1)),
                _createTextVNode(" " + _toDisplayString(_unref(f2dec)(_unref(controle).item.valorDesconto)), 1)
              ]),
              _createElementVNode("div", _hoisted_47, [
                _cache[40] || (_cache[40] = _createElementVNode("b", null, "Valor Receber:", -1)),
                _createTextVNode(" " + _toDisplayString(_unref(f2dec)(_unref(controle).item.valorReceber)), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              _cache[47] || (_cache[47] = _createElementVNode("div", { class: "col-md-12" }, [
                _createElementVNode("b", null, "Banco:")
              ], -1)),
              _createElementVNode("div", _hoisted_50, [
                _cache[42] || (_cache[42] = _createElementVNode("b", null, "Valor documento:", -1)),
                _createTextVNode(" " + _toDisplayString(_unref(f2dec)(_unref(controle).item.valorDocumento)), 1)
              ]),
              _createElementVNode("div", _hoisted_51, [
                _cache[43] || (_cache[43] = _createElementVNode("b", null, "Valor mora juros:", -1)),
                _createTextVNode(" " + _toDisplayString(_unref(f2dec)(_unref(controle).item.valorMoraJuros)) + " ", 1),
                (_unref(controle).item.valorMoraJuros != _unref(controle).item.valorReceberJuros)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_52, " (Dif: " + _toDisplayString(_unref(f2dec)((_unref(controle).item.valorMoraJuros ?? 0) - (_unref(controle).item.valorReceberJuros ?? 0))) + ") ", 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_53, [
                _cache[44] || (_cache[44] = _createElementVNode("b", null, "Valor outros créditos:", -1)),
                _createTextVNode(" " + _toDisplayString(_unref(f2dec)(_unref(controle).item.valorOutrosCreditos)) + " ", 1),
                (_unref(controle).item.valorOutrosCreditos != _unref(controle).item.valorReceberMulta)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_54, " (Dif: " + _toDisplayString(_unref(f2dec)((_unref(controle).item.valorOutrosCreditos ?? 0) - (_unref(controle).item.valorReceberMulta ?? 0))) + ") ", 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_55, [
                _cache[45] || (_cache[45] = _createElementVNode("b", null, "Valor desconto:", -1)),
                _createTextVNode(" " + _toDisplayString(_unref(f2dec)(_unref(controle).item.valorDesconto)) + " ", 1),
                (_unref(controle).item.valorDesconto != _unref(controle).item.valorDesconto)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_56, " (Dif: " + _toDisplayString(_unref(f2dec)((_unref(controle).item.valorDesconto ?? 0) - (_unref(controle).item.valorDesconto ?? 0))) + ") ", 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_57, [
                _cache[46] || (_cache[46] = _createElementVNode("b", null, "Valor pago:", -1)),
                _createTextVNode(" " + _toDisplayString(_unref(f2dec)(_unref(controle).item.valorPago)) + " ", 1),
                (_unref(controle).item.valorPago != _unref(controle).item.valorReceber)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_58, " (Dif: " + _toDisplayString(_unref(f2dec)((_unref(controle).item.valorPago ?? 0) - (_unref(controle).item.valorReceber ?? 0))) + ") ", 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["exibir"]),
    _createElementVNode("nav", _hoisted_59, [
      _createElementVNode("div", _hoisted_60, [
        _createElementVNode("div", _hoisted_61, [
          _cache[49] || (_cache[49] = _createElementVNode("ul", { class: "navbar-nav me-auto mb-2 mb-lg-0" }, null, -1)),
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("ul", _hoisted_63, [
              _createElementVNode("li", _hoisted_64, [
                _createElementVNode("a", {
                  class: "nav-link",
                  href: "#",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_unref(router).back()))
                }, [...(_cache[48] || (_cache[48] = [
                  _createElementVNode("i", { class: "fa fa-close" }, null, -1),
                  _createTextVNode(" Fechar ", -1)
                ]))])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})